import { getTypes } from "./TypeGenerator";

export const SchoolTypes = {
    ...getTypes("SCHOOL"),
    UPDATE_SCHOOL_PROFILE: "UPDATE_SCHOOL_PROFILE",
    UPDATE_SCHOOL_PROFILE_SUCCESS: "UPDATE_SCHOOL_PROFILE_SUCCESS",
};
